<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/my-listings" routerDirection="back" data-cy="listDet-hdr-backBtn">
      </ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <app-profile-component data-cy="listDet-hdr-profileBtn" (click)="openMyProfile()"></app-profile-component>

      <ion-button *ngIf="!offlineMode" (click)="openHelp()" data-cy="listDet-hdr-helpBtn">
        <ion-icon slot="icon-only" name="help-circle-sharp"></ion-icon>
      </ion-button>

      <ion-button *ngIf="offlineMode" (click)="common.openOfflineModal()">
        <ion-icon slot="icon-only" name="cloud-offline-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title data-cy="listDet-hdr-title">Listing Detail</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="padding">
  <div *ngIf="loaded" class="appPage">
    <ion-list>
      <div class="position-relative">


        <h2 class="list-address link" *ngIf="!currentListing.address?.title" (click)="openEditModal('address')"
          data-cy="listDet-address-placeholder">
          Add Listing Address
        </h2>

        <!-- <div class="address-title-parent" *ngIf="!isMapVisible && currentListing.address?.title">
          <h2 class="address-title link" *ngIf="currentListing.address?.title" (click)="openEditModal('address')"
            data-cy="listDet-address-realAddress">
            {{currentListing.address?.title}}
          </h2>
        </div> -->

        <div class="map-cont" data-cy="listDet-address-mapContent">
          <div class="map-overlay"></div>
          <img class="fake-image" hidden [src]="currentListing.address?.title | mapUrl"
            *ngIf="currentListing.address?.placeId" />
          <div>
            <div #map *ngIf="isMapVisible" id="map">
              <img #mapImg [src]="mapSrc" *ngIf="mapSrc" />
            </div>
            <div #map *ngIf="!isMapVisible" id="map">
              <img #mapImg />
            </div>
          </div>
          <div class="map-content2 title-chip-container">
            <p class="map-content link" (click)="openEditModal('address')" tappable
              data-cy="listDet-address-realAddress">
              {{currentListing.address?.title}}
            </p>
            <div *ngIf="openHouseEvents?.length" class="chips-container">
              <ion-chip class="open-house-time-chip link" (click)="openScheduler()"
                [style.backgroundColor]="openHouseEvents[0].color">
                <ion-icon name="checkmark-circle-outline" />
                <ion-label>
                  <!-- Single time slot vs multiple time slots -->
                  {{
                  openHouseEvents.length === 1
                  ? openHouseEvents[0].formattedShortDate
                  : openHouseEvents.length + " Open Houses Assigned"
                  }}
                </ion-label>
              </ion-chip>
            </div>
          </div>
        </div>

        <!-- loan officer / paired-agent div -->
        <div class="map-content2" *ngIf="ifListingIsAvailable">

          <div *ngIf="role === 'agentAdmin'" class="admin-control-wrapper">
            <div class="admin-controls">
              <div class="avatars-container" (click)="openPairedAgentInfoAlert()">
                <avatar *ngFor="let avatar of pairedAgentsAvatarInfo" class="agent-avatar" [imageURL]="avatar.imageURL"
                  [avatarName]="avatar.initials" size="35px" />

                <avatar *ngIf="overflowAgents > 0" class="agent-avatar overflow-avatar"
                  [avatarName]="'+' + overflowAgents" />
              </div>

              <ion-button *ngIf="!currentListing.sampleListing" (click)="openPairedAgentInfoAlert()" fill="clear"
                size="small">
                Edit Assigned Agents
                <ion-icon slot="start" name="person-outline" />
              </ion-button>


              <ion-button *ngIf="!currentListing.sampleListing" (click)="editSchedule($event)"
                [class.disabled-btn]="currentListing?.listingDetails?.saleStatus === 'inactive'" color fill="clear"
                size="small">

                Schedule Open Houses
                <ion-icon slot="start" name="calendar-outline" />
              </ion-button>
            </div>
          </div>

          <div class="loanOfficerDiv" *ngIf="(role === 'lender') && totalPairedAgents.length > 1">
            <div class="loanOfficerWrapper link" data-cy="listDet-pairedAgent-learnMoreBtn"
              (click)="openPairedAgentInfoAlert()">
              <div class="loanOfficerImgDiv">
                <app-profile-image-item class="loanOfficerImg multipleAgents"
                  [profile]="pairedAgent"></app-profile-image-item>
                <div class="paired-agent-block">
                  +{{totalPairedAgents.length-1}}
                </div>
              </div>
              <div class="loanOfficerSection new-paired-agent">
                <div class="subTitle bold" data-cy="listDet-pairedLender-name">
                  {{totalPairedAgents.length}} paired agents
                </div>
                <div class="subTitle bold">Learn More</div>
              </div>
            </div>
          </div>

          <div class="loanOfficerDiv" *ngIf="(role === 'lender') && totalPairedAgents.length < 2">
            <div class="loanOfficerWrapper link" data-cy="listDet-pairedAgent-learnMoreBtn"
              (click)="openPairedAgentInfoAlert()">
              <div class="loanOfficerImgDiv">
                <app-profile-image-item class="loanOfficerImg singleAgent"
                  [profile]="pairedAgent"></app-profile-image-item>
              </div>
              <div class="loanOfficerSection">
                <span class="normal">Paired Agent:</span>
                <div class="pad-5 subTitle bold" data-cy="listDet-pairedLender-name">
                  {{pairedAgent.username}}
                </div>
                <div class="pad-5 subTitle bold">Learn More</div>
              </div>
            </div>
          </div>

          <div *ngIf="!lenderOverride && currentListing.enhancedMode && loanOfficer.name !== '' && role === 'agent'"
            class="loanOfficerDiv">
            <div class="loanOfficerWrapper link" (click)="showEnhancedModal()"
              data-cy="listDet-pairedLender-learnMoreBtn">
              <div class="loanOfficerImgDiv">
                <app-profile-image-item class="loanOfficerImg singleAgent"
                  [profile]="loanOfficer"></app-profile-image-item>
              </div>
              <div class="loanOfficerSection">
                <span class="normal">Paired Lender:</span>
                <div class="pad-5 subTitle bold" data-cy="listDet-pairedLender-name">
                  {{loanOfficer.name}}
                </div>
                <div class="pad-5 subTitle bold">Learn More</div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!lenderOverride && !currentListing.enhancedMode && role === 'agent'"
          class="map-content2 loanOfficerEmptyDiv">
          <div class="loanOfficerWrapper link" (click)="showEnhancedModal('enableEnhanced')"
            data-cy="listDet-nonPairedLender-learnMoreBtn">
            <div class="loanOfficerSection">
              <span class="normal">Pair a Lender to unlock Enhanced Features at no cost</span>
              <div class="subTitle bold" style="padding-top: 5px">
                Learn More
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="role === 'agent' && totalPairedAgents.length > 1 && footerText"
        class="map-content2 footerText smallLightText">
        {{footerText}}
        <span class="link" (click)="clickInfoText()">
          <ion-icon slot="icon-only" name="information-circle" class="link noTooltip"></ion-icon>
        </span>
      </div>

      <div class="spacer-20"></div>

      <app-custom-screens-input *ngIf="currentListing && !restrictMarketingServiceOnly"
        [currentListing]="currentListing" (webimage)="onFileChanged($event)" (clicked)="editKioskImage($event)"
        (deleted)="removeKioskImage($event)" (makeDefault)="makeImageDefault($event)"
        [suggestedlistingImages]="suggestedlistingImages" [property]="currentListing.propertyImage"
        (cancelImageEvent)="cancelImageEvent($event)" (selectImageEvent)="selectImageEvent($event)">
      </app-custom-screens-input>

      <div class="spacer-20"></div>

      <div class="segmentSectionOverflow centerAlign" *ngIf="!restrictMarketingServiceOnly">
        <div class="segmentSection">
          <button #openhouseElement class="segmentButton"
            [ngClass]="{'enabledSegment' : (segmentValue === 'openhouse')}"
            (click)="segmentChanged('openhouse', openhouseElement)" data-cy="listDet-openHouseSignInBtn">
            {{openHouse}}
          </button>
          <button #micrositeElement class="segmentButton"
            [ngClass]="{'enabledSegment' : (segmentValue === 'microsite')}"
            (click)="segmentChanged('microsite', micrositeElement)" data-cy="listDet-micrositeBtn">
            Microsite
          </button>
          <button #marketingElement class="segmentButton"
            [ngClass]="{'enabledSegment' : (segmentValue === 'marketing' && isInternetAvailable)}"
            (click)="segmentChanged('marketing', marketingElement)" data-cy="listDet-marketingBtn">
            Marketing
          </button>
        </div>
      </div>

      <div class="spacer-20"></div>

      <div class="segmentDiv" [ngSwitch]="segmentValue">
        <section *ngSwitchCase="'openhouse'">
          <div class="layout-header" ion-padding-top>
            <div class="flex-container">
              <h3 data-cy="listDet-houseSignIn-layout-txt" class="pad-right-10">Layout</h3> <ion-chip
                *ngIf="disclosureDoc && disclosureLock === true" class="disclosureLockAccepted">
                <ion-icon color="primary" src="assets/imgs/document-text-outline.svg"></ion-icon>
                <ion-label>{{disclosureDoc?.title}}</ion-label>
              </ion-chip>
            </div>

            <!-- disclosures popover -->
            <ion-list *ngIf="disclosureDoc && disclosureDoc.title">
              <ion-item>
                <ion-icon color="primary" src="assets/imgs/document-text-outline.svg"></ion-icon>

                <ion-select aria-label="Disclosure" interface="popover" placeholder="Add Disclosure"
                  [(ngModel)]="selectedDisclosure" (ionChange)="onDisclosureChange($event)">
                  <ion-select-option *ngIf="disclosureDoc && disclosureDoc.title"
                    [value]="disclosureDoc?.title">{{disclosureDoc?.title}}</ion-select-option>
                  <ion-select-option value="addDisclosure">Add Disclosure</ion-select-option>

                </ion-select>
              </ion-item>
            </ion-list>

            <ion-button *ngIf="!disclosureDoc || !disclosureDoc.title" fill="clear" slot="end"
              (click)="addDisclosure()">
              <ion-icon slot="start" color="primary" src="assets/imgs/document-text-outline.svg"></ion-icon>
              <ion-label>Add Disclosure</ion-label>
            </ion-button>

            <!--
            <ion-button ion-button tappable color="primary" (click)="openLayoutPreview()">
              Layout Preview
              <ion-icon end margin-left name="arrow-forward-sharp" color="white"></ion-icon>
            </ion-button>
            -->
          </div>

          <app-property-layout-selector [listing]="currentListing" (onSelect)="selectPropertyLayout($event)"
            data-cy="listDet-houseSignIn-layout-selector">
          </app-property-layout-selector>

          <!-- ADDITIONAL OPTIONS -->
          <h3 class="x-spaces">
            Additional Options
            <!-- <ion-icon class="link" name="color-wand-outline"
              (click)="generateContent()"></ion-icon> -->
          </h3>
          <label class="item item-input follow-up flex-wrap">
            <div class="flex-nowrap">
              <span class="input-label row-title" data-cy="listDet-houseSignIn-addtlOpt-enableGuest-txt">Enable Guest
                Follow Up</span>

              <ion-toggle *ngIf="toggleMode === 'md'" [disabled]="dataIsLoading" mode="md" [(ngModel)]="guestFollowUp"
                (ionChange)="guestFollowUpChanged($event.detail)" color="success"
                data-cy="listDet-houseSignIn-addtlOpt-enableGuest-toggle"></ion-toggle>
              <ion-toggle *ngIf="toggleMode === 'ios'" [disabled]="dataIsLoading" mode="ios" [(ngModel)]="guestFollowUp"
                (ionChange)="guestFollowUpChanged($event.detail)" color="success"
                data-cy="listDet-houseSignIn-addtlOpt-enableGuest-toggle"></ion-toggle>
            </div>
            <div class="table-cont" *ngIf="currentListing.guestFollowUp">
              <!-- should not be using table, old legacy code -->
              <table>
                <tr class="link">
                  <td width="180" data-cy="listDet-houseSignIn-addtlOpt-enableGuest-msg1-txt">
                    Text Message 1
                  </td>
                  <td (click)="openEditModal('message', 'Text Message 1')"
                    data-cy="listDet-houseSignIn-addtlOpt-enableGuest-msg1-value">
                    <span>{{currentListing.textMessage}}</span>
                  </td>
                </tr>
                <tr class="link">
                  <td width="180" data-cy="listDet-houseSignIn-addtlOpt-enableGuest-msg2-txt">
                    Text Message 2
                  </td>
                  <td (click)="openEditModal('link', 'Text Message 2')"
                    data-cy="listDet-houseSignIn-addtlOpt-enableGuest-msg2-value">
                    <span>{{currentListing.linkToInfo || linkPlaceholder}}</span>
                  </td>
                </tr>
              </table>
            </div>
          </label>
          <div *ngFor="let question of kioskQuestions; index as i">
            <div *ngIf="i > 0">
              <div class="question-expandable" [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i">
                <label class="item item-input follow-up flex-wrap">
                  <div class="flex-nowrap">
                    <span class="input-label row-title extra-bottom-margin"
                      [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-txt'">
                      <div class="flex-container">
                        <ion-label>Additional Question {{i}} </ion-label>
                        <ion-icon *ngIf="i === 1 && disclosureLock === true" src="assets/imgs/lock-closed.svg"
                          class="link pad-left-5" (click)="adminLocked()"></ion-icon>

                        <div class="disclosureLockDiv" *ngIf="i === 1 && disclosureLock === true">
                          <ion-chip class="disclosureLockAccepted">
                            <ion-icon color="primary" src="assets/imgs/document-text-outline.svg"></ion-icon>
                            <ion-label>{{disclosureDoc?.title}}</ion-label>
                          </ion-chip>
                        </div>
                      </div>


                      <!-- <span *ngIf="kioskQuestions[i-1].conditionalToggle && kioskQuestions[i-1].type === 'yesNo'">(Triggered)</span> -->
                    </span>
                    <ion-toggle *ngIf="toggleMode === 'md'" [disabled]="dataIsLoading || (disclosureLock && i === 1)"
                      mode="md" color="success" [(ngModel)]="question.isActive"
                      (ionChange)="toggleChanged(question, i, $event.detail)"
                      [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-toggle'">
                    </ion-toggle>
                    <ion-toggle *ngIf="toggleMode === 'ios'" [disabled]="dataIsLoading || (disclosureLock && i === 1)"
                      mode="ios" color="success" [(ngModel)]="question.isActive"
                      (ionChange)="toggleChanged(question, i, $event.detail)"
                      [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-toggle'">
                    </ion-toggle>


                  </div>

                  <div class="disclosureLockSmartphoneDiv" *ngIf="i === 1 && disclosureLock === true">
                    <ion-chip class="disclosureLockAccepted">
                      <ion-icon color="primary" src="assets/imgs/document-text-outline.svg"></ion-icon>
                      <ion-label>{{disclosureDoc?.title}}</ion-label>
                    </ion-chip>
                  </div>

                  <!-- <div (click)="openEditModal(1)" class="item item-input follow-up flex-wrap cond-warn"
                    *ngIf="kioskQuestions[i-1].conditionalToggle && kioskQuestions[i-1].type === 'yesNo'">
                    <a *ngIf="kioskQuestions[i-1].conditionalTriggerAnswer" class="cond-messg"
                      [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-question-value'">Triggered when answer to
                      previous question is "Yes"
                      <ion-icon class="cond-icon cond-mob" name="create-outline"></ion-icon>

                    </a>
                    <a *ngIf="!kioskQuestions[i-1].conditionalTriggerAnswer" class="cond-messg"
                      [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-question-value'">Triggered when answer to
                      previous question is "No"
                      <ion-icon class="cond-icon cond-mob" name="create-outline"></ion-icon>
                    </a>
                    <ion-icon class="cond-icon cond-pc" name="create-outline"></ion-icon>
                  </div> -->

                  <div class="table-cont" *ngIf="question.isActive === true"
                    [ngClass]="{'isExpanded' : question.isActive}">
                    <table>
                      <tr class="link" (click)="openEditModal(i)">
                        <td width="100" [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-question-txt'">
                          Question
                        </td>
                        <td>
                          <span
                            [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-question-value'">{{question.question}}</span>
                        </td>
                      </tr>
                      <tr>
                        <td [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-type-txt'">
                          Type
                        </td>
                        <td class="wrap-fix">
                          <ion-button class="button-md" mode="md" [ngClass]="{'active': question.type === 'text'}"
                            ion-button (click)="questionTypeSelected(question, i, 'text')"
                            [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-type-txtBtn'">Text</ion-button>
                          <ion-button class="button-md" mode="md" [ngClass]="{'active': question.type === 'number'}"
                            ion-button (click)="questionTypeSelected(question, i, 'number')"
                            [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-type-numBtn'">Number</ion-button>
                          <ion-button class="button-md" mode="md" [ngClass]="{'active': question.type === 'yesNo'}"
                            ion-button (click)="questionTypeSelected(question, i, 'yesNo')"
                            [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-type-boolBtn'">Yes/No</ion-button>
                          <ion-button class="button-md" mode="md"
                            [ngClass]="{'active': question.type === 'multipleChoice'}" ion-button
                            [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-choicesBtn'"
                            (click)="questionTypeSelected(question, i, 'multipleChoice')">Choice</ion-button>
                        </td>
                      </tr>
                      <tr *ngIf="question.type === 'multipleChoice'">
                        <td>Choices</td>
                        <td>
                          <ion-reorder-group class="multiple-choice-reorder" *ngIf="question.answers"
                            [disabled]="(disclosureLock && i === 1)" lines="none"
                            (ionItemReorder)="reorderMultipleChoiceQuestionAnswers(question, $event, i)"
                            reorder="!(disclosureLock && i === 1)"
                            data-cy="listDet-houseSignIn-addtlOpt-choicesReorderGroup">
                            <ion-item button="false" class="reorder-item" lines="none"
                              *ngFor="let answer of question.answers; index as j">
                              <a class="clickEnableCls bold" (click)="openEditModalMultipleChoice(question, j, i)"
                                [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-choicesBtn-choice-' + j">
                                <!-- <p *ngIf="!answer" class="item-label-text">Enter option...</p> -->
                                <p class="item-label-text flex-container vertical-align">
                                  <span *ngIf="answer === ''" class="placeholder">Edit Choice</span>
                                  {{ answer }}<ng-container *ngIf="answer && answer !== ''">
                                    <img
                                      *ngIf="question.details && question.details[j] && question.details[j].selectionType === 'ChoiceOnly'"
                                      class="vertical-align multiChoiceIcon"
                                      src="/assets/imgs/ChoiceActive-choice-only.svg" />
                                    <img
                                      *ngIf="question.details && question.details[j] && question.details[j].selectionType === 'ChoiceWithDetails'"
                                      class="vertical-align multiChoiceIcon"
                                      src="/assets/imgs/ChoiceActive-with-details.svg" />
                                    <img *ngIf="!question.details || !question.details[j]"
                                      class="vertical-align multiChoiceIcon"
                                      src="/assets/imgs/ChoiceActive-choice-only.svg" />
                                  </ng-container>
                                </p>
                              </a>
                              <a class="clickEnableCls bold" (click)="openEditModalMultipleChoice(question, j, i)">
                              </a>
                              <ion-reorder mode="ios" slot="end" icon="menu"
                                [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-choicesBtn-choice-' + j + '-reorder'"></ion-reorder>
                            </ion-item>
                          </ion-reorder-group>
                          <div *ngIf="question.answers && question.answers.length > 0" class="spacer-20"></div>
                          <ion-button *ngIf="!question.answers || (question.answers && question.answers.length < 5)"
                            (click)="addMultipleChoiceAnswer(question, i)" mode="md" class="add-answer-button"
                            ion-button [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-choicesBtn-addChoice'">
                            <ion-icon slot="start" name="add"></ion-icon>
                            <ion-label>Add Choice</ion-label>
                          </ion-button>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <!-- <div class="flex-nowrap" *ngIf=" i === 1 && question.type === 'yesNo'">
                    <span class="input-label row-title extra-bottom-margin"
                      [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-txt'">Conditional Logic <ion-icon
                        size="small" (click)="showConditionalModal()" name="information-circle-outline"></ion-icon>
                      </span>
                    <ion-toggle [disabled]="dataIsLoading" mode="ios" color="success"
                      [(ngModel)]="question.conditionalToggle"
                      (ionChange)="toggleConditional(question, i, $event.detail)"
                      [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-toggle'">
                    </ion-toggle>
                  </div> -->

                  <!-- <div *ngIf="question.conditionalToggle && question.type === 'yesNo'" class="table-cont">
                    <table>
                      <tr>

                        <td><span [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-question-value'">What Answer
                            Triggers Question {{i+1}}?</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="wrap-fix">
                          <div class="pc-link">
                            <ion-button class="button-md" mode="md"
                              [ngClass]="{'active': question.conditionalTriggerAnswer}" ion-button
                              (click)="conditionalResponse(question,i,$event)"
                              [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-type-txtBtn'">Yes</ion-button>
                            <ion-button class="button-md" mode="md"
                              [ngClass]="{'active': !question.conditionalTriggerAnswer}" ion-button
                              (click)="conditionalResponse(question,i,$event)"
                              [attr.data-cy]="'listDet-houseSignIn-addtlOpt-' + i + '-type-numBtn'">No</ion-button>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div> -->
                </label>
              </div>
            </div>
          </div>
        </section>

        <section *ngSwitchCase="'microsite'">
          <div [ngClass]="currentListing.webPublished ? '' : 'disabled-microsite-link'" class="propertyInfo link">
            <div>
              <label class="linkWrapper">
                <ion-grid no-padding>
                  <ion-row class="fullWidth">
                    <ion-col col-6 id="microsite_url">
                      <div class="link pad-top-15 pad-bottom-10" *ngIf="currentListing.webPublished === true"
                        (click)="openSlugLink();" data-cy="listDet-microsite-info-micrsUrl-link">
                        {{env.blockparty}}{{currentListing.slug}}
                      </div>
                      <div class="link disabled-text pad-top-15 pad-bottom-10" (click)="scrollToPublish()"
                        *ngIf="!currentListing.webPublished || currentListing.webPublished !== true"
                        data-cy="listDet-microsite-info-micrsUrl-noLink">
                        Your Microsite hasn't been published.
                      </div>
                    </ion-col>

                    <ion-col class="inline-block" id="overflow_menu" col-6>
                      <div class="listing-title-hgt pc-lnk" style="line-height: 35px" class="floatRight inline-block">
                        <div class="listingShareIcons">
                          <ion-button
                            (click)="currentListing.webPublished ? copySlug($event) : openNeedPublishedMicrositeModal()"
                            *ngIf="number_of_buttons > 0" size="small" fill="clear" class="cpy-lnk-marg inline-block"
                            ion-button data-cy="microsite-preview-hdr-copyBtn" data-cy="microsite-preview-hdr-copy">
                            <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="copy-outline"></ion-icon>
                          </ion-button>
                          <ion-button
                            (click)="currentListing.webPublished ? shareListing(currentListing, $event) : openNeedPublishedMicrositeModal()"
                            *ngIf="number_of_buttons > 1" size="small" fill="clear"
                            data-cy="microsite-preview-hdr-share">
                            <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="share-social-outline"></ion-icon>
                          </ion-button>
                          <ion-button
                            (click)="currentListing.webPublished ? saveQR($event) : openNeedPublishedMicrositeModal()"
                            *ngIf="number_of_buttons > 2" size="small" fill="clear"
                            data-cy="microsite-preview-hdr-qr-code">
                            <ion-icon class="cpy-lnk pc-lnk mob-cpy" name="qr-code-outline"></ion-icon>
                          </ion-button>
                          <ion-button
                            (click)="currentListing.webPublished ? presentMorePopover($event) : openNeedPublishedMicrositeModal()"
                            class="moreButton" size="small" fill="clear" data-cy="microsite-preview-hdr-moreBtn">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                          </ion-button>
                        </div>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </label>
              <!-- HERE -->
            </div>

            <div class="listingTitleSection" data-cy="listDet-microsite-info">
              Property Info
            </div>
            <div>
              <ion-grid class="propertyAdvancedSection link">
                <ion-row class="propertyItem" (click)="openEditModal('microsite')">
                  <ion-col class="propertyTitle" data-cy="listDet-microsite-advInfo-price-lbl">Price</ion-col>
                  <ion-col><span class="propertyValue"
                      data-cy="listDet-microsite-advInfo-price-btn">{{common.formatCurrency(currentListing.listingDetails.price,
                      'USD')}}</span>
                  </ion-col>
                </ion-row>
                <div *ngIf="!noSuggestions">
                  <ion-row class="auto-populate-row" *ngIf="price?.length > 0 && !currentListing?.listingDetails.price">
                    <app-auto-populate-item [message]="price" key="price" (cancel)="cancelEvent($event)"
                      (select)="selectEvent($event)">
                    </app-auto-populate-item>
                  </ion-row>
                </div>
                <ion-row class="propertyItem" (click)="openEditModal('microsite')">
                  <ion-col class="propertyTitle" data-cy="listDet-microsite-advInfo-beds-lbl">Beds</ion-col>
                  <ion-col><span class="propertyValue"
                      data-cy="listDet-microsite-advInfo-beds-btn">{{common.formatNumber(currentListing.listingDetails.beds)}}</span>
                  </ion-col>
                </ion-row>
                <div *ngIf="!noSuggestions">
                  <ion-row class="auto-populate-row" *ngIf="beds?.length > 0 && !currentListing.listingDetails.beds">
                    <app-auto-populate-item [message]="beds" key="beds" (cancel)="cancelEvent($event)"
                      (select)="selectEvent($event)">
                    </app-auto-populate-item>
                  </ion-row>
                </div>
                <ion-row class="propertyItem" (click)="openEditModal('microsite')">
                  <ion-col class="propertyTitle" data-cy="listDet-microsite-advInfo-baths-lbl">Baths</ion-col>
                  <ion-col><span class="propertyValue"
                      data-cy="listDet-microsite-advInfo-baths-btn">{{common.formatNumber(currentListing.listingDetails.baths)}}</span>
                  </ion-col>
                </ion-row>
                <div *ngIf="!noSuggestions">
                  <ion-row class="auto-populate-row" *ngIf="baths?.length > 0 && !currentListing.listingDetails.baths">
                    <app-auto-populate-item [message]="baths" key="baths" (cancel)="cancelEvent($event)"
                      (select)="selectEvent($event)">
                    </app-auto-populate-item>
                  </ion-row>
                </div>
                <ion-row class="propertyItem" (click)="openEditModal('microsite')">
                  <ion-col class="propertyTitle" data-cy="listDet-microsite-advInfo-sqFeet-lbl">Square Feet
                  </ion-col>
                  <ion-col><span class="propertyValue"
                      data-cy="listDet-microsite-advInfo-sqFeet-btn">{{common.formatNumber(currentListing.listingDetails.squareFootage)}}</span>
                  </ion-col>
                </ion-row>
                <div *ngIf="!noSuggestions">
                  <ion-row class="auto-populate-row"
                    *ngIf="squareFootage?.length > 0 && !currentListing.listingDetails.squareFootage">
                    <app-auto-populate-item [message]="squareFootage" key="squareFootage" (cancel)="cancelEvent($event)"
                      (select)="selectEvent($event)">
                    </app-auto-populate-item>
                  </ion-row>
                </div>
              </ion-grid>
            </div>

            <div>
              <ion-item *ngIf="currentListing.enhancedMode" fill="clear" lines="none" class="selectItemProperty link">
                <ion-label slot="start" class="saleStatusLabel" data-cy="listDet-microsite-advInfo-status-lbl">Sale
                  Status</ion-label>
                <ion-select fill="clear" slot="end" class="ionSelectSaleStatus" lines="none"
                  [(ngModel)]="currentListing.listingDetails.saleStatus" (ionChange)="updateListing('saleStatus');"
                  interface="popover" data-cy="listDet-microsite-advInfo-status-dd">
                  <ion-select-option value="--">--</ion-select-option>
                  <ion-select-option value="Closed Sale">Closed Sale</ion-select-option>
                  <ion-select-option value="Coming Soon">Coming Soon</ion-select-option>
                  <ion-select-option value="Contingent">Contingent</ion-select-option>
                  <ion-select-option value="For Sale">For Sale</ion-select-option>
                  <ion-select-option value="For Lease">For Lease</ion-select-option>
                  <ion-select-option value="Pending">Pending</ion-select-option>
                  <ion-select-option value="inactive">Inactive</ion-select-option>
                </ion-select>
              </ion-item>

              <ion-grid *ngIf="currentListing.enhancedMode === false" class="propertyAdvancedSection link"
                (click)="showPairedLenderError()">
                <ion-row class="propertyItem">
                  <ion-col class="propertyTitle" data-cy="listDet-microsite-advInfo-dscr-lbl">Sale Status</ion-col>
                  <ion-col>
                    <p class="propertyValue propertyDesc" data-cy="listDet-microsite-advInfo-dscr-value">
                      {{currentListing.listingDetails.saleStatus || '--'}}
                    </p>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>

            <div>
              <ion-grid class="propertyAdvancedSection link" (click)="openEditModal('propertyDescription')">
                <ion-row class="propertyItem">
                  <ion-col class="propertyTitle" data-cy="listDet-microsite-advInfo-dscr-lbl">Description</ion-col>
                  <ion-col>
                    <p class="propertyValue propertyDesc" data-cy="listDet-microsite-advInfo-dscr-value">
                      {{currentListing.listingDetails.description || '--'}}
                    </p>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>

            <div>
              <ion-grid class="propertyAdvancedSection link" (click)="openEditModal('propertyURL')">
                <ion-row class="propertyItem">
                  <ion-col class="propertyTitle" data-cy="listDet-microsite-advInfo-moreInfo-lbl">More Info URL
                  </ion-col>
                  <ion-col><span class="propertyValue"
                      data-cy="listDet-microsite-advInfo-moreInfo-value">{{currentListing.listingDetails.moreInfoURL ||
                      '--'}}</span>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>

            <div class="spacer-15"></div>
            <div class="listingTitleSection" data-cy="listDet-microsite-tourInfo-header">
              Property Tour Info
            </div>

            <ion-list lines="none">
              <ion-reorder-group lines="none" reorder="false">
                <ion-item button="false" class="tourLinks" lines="none" *ngFor="let item of currentListing.tourLinks">
                  <ion-checkbox slot="start" (ionChange)="tourLinkChanged(item)" [(ngModel)]="item.enabled" mode="ios"
                    [attr.data-cy]="'listDet-microsite-tourInfo-' + item.id + '-checkbox'">
                  </ion-checkbox>
                  <a class="clickEnableCls bold" (click)="openEditModal('tourLink', item)">
                    <span class="urlLinkHeader" [attr.data-cy]="'listDet-microsite-tourInfo-' + item.id + '-title'">{{
                      item?.title }}
                    </span>

                    <ion-label fill="clear" *ngIf="item.URL !== ''" class="normal linkLabel"
                      [attr.data-cy]="'listDet-microsite-tourInfo-' + item.id + '-url'">{{item.URL}}
                    </ion-label>

                    <ion-label *ngIf="item.URL === ''" class="normal linkLabel urlLink"
                      [attr.data-cy]="'listDet-microsite-tourInfo-' + item.id + '-noUrl'">Add URL
                    </ion-label>
                  </a>
                </ion-item>
              </ion-reorder-group>
            </ion-list>
          </div>
        </section>

        <section *ngSwitchCase="'marketing'" class="marketing-container">
          <div class="listingTitleSection" data-cy="myPairedLender-agents-title">
            Marketing Services
          </div>
          <div class="light-text">
            In addition to our own services, we've also secured
            exclusive deals with other companies just for Curb Hero
            users
          </div>

          <algolia-automatic-search #algoliaAutomaticMarketingServicesSearch [instanceName]="instanceName"
            noResultsMessage="No more results" [childComponent]="hitTemplate" />

          <ng-template #hitTemplate let-hit>
            <app-marketplace-service-items [listingId]="currentListing.id" class="marketingItem"
              [marketserviceitem]="hit" (onEvents)="listingEvents($event)"
              (objClicked)="trackMarketingAnalytics(hit)" />
          </ng-template>
        </section>
      </div>
    </ion-list>

    <div class="buttons segmentDiv">
      <span *ngIf="segmentValue === 'microsite'">
        <ion-button ion-button *ngIf="currentListing.webPublished" (click)="publishToMicrosite(false)"
          data-cy="listDet-microsite-publishedBtn">Published
        </ion-button>
        <ion-button id="publishMicrositeButton" class="largeButton" [ngClass]="isPaired" ion-button
          *ngIf="!currentListing.webPublished" outline (click)="publishToMicrosite(true)"
          data-cy="listDet-microsite-publishBtn">Publish Listing Microsite
        </ion-button>

        <ion-button fill="clear" (click)="presentPopover($event)" data-cy="listDet-microsite-editBtn">
          <ion-icon name="ellipsis-vertical-sharp"></ion-icon>
        </ion-button>
      </span>

      <ng-container *ngIf="segmentValue === 'openhouse'">
        <ion-button class="largeButton button-md" ion-button (click)="launchOpenHouse()" tappable
          data-cy="listDet-houseSignIn-launchBtn" [ngClass]="isPaired">Launch Open House Sign-in</ion-button>

        <ion-button fill="clear" (click)="presentPopover($event)" data-cy="listDet-houseSignIn-editBtn">
          <ion-icon name="ellipsis-vertical-sharp"></ion-icon>
        </ion-button>
      </ng-container>

      <!--
      <ion-button ion-button delete-listing (click)="deleteListing()" tappable outline *ngIf="isListingValid()">
        Delete Listing
      </ion-button>
      -->
    </div>

    <div class="link margin-left-10 segmentDiv" *ngIf="currentListing.webPublished && segmentValue === 'microsite'">
      <div data-cy="listDet-microsite-notSeeingUpdates-txt">
        Not seeing updates?
      </div>
      <div class="manualSync link" (click)="manualSync();" data-cy="listDet-microsite-manuallySyncBtn">
        <span class="bold">Manually sync changes</span>
        <img src="assets/imgs/sync.png" />
      </div>
    </div>

    <div class="spacer-100"></div>
  </div>

  <div *ngIf="!loaded" class="appPage">
    <div class="skeletonContainer" *ngIf="!loaded">
      <ion-skeleton-text animated style="height: 80px; width: 80px"></ion-skeleton-text>

      <div class="skeletonSub">
        <ion-skeleton-text animated style="height: 12px; width: 80%; margin-top: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated style="height: 12px; width: 70%; margin-top: 5px"></ion-skeleton-text>
        <ion-skeleton-text animated style="height: 12px; width: 50%; margin-top: 5px"></ion-skeleton-text>
      </div>
    </div>
  </div>
</ion-content>